import React from "react"
import styled from "styled-components"
import { HeadingTwo, HeadingThree, Paragraph } from "buoy-core"
import responsive from "../../common/responsive"
import Section from "../Section"
import { LazyResImage } from "../../common/responsive"

const StyledHeadingTwo = styled(HeadingTwo)`
  text-align: center;
`

const InfoContainer = styled.div`
  display: flex;
  ${responsive("flex-direction", "row", "row", "row", "column")};
  ${responsive(
    "align-items",
    "flex-start",
    "flex-start",
    "flex-start",
    "center"
  )};
  justify-content: space-between;
  width: 100%;
  max-width: 900px;
  text-align: center;
`

const SubSectionContainer = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${responsive("padding", "20px", "20px", "20px", "40px")};
`

const Image = styled.img`
  position: relative;
  width: auto;
  height: 80px;
`
const Dots = styled.div`
  position: absolute;
  ${responsive("width", "60%", "60%", "60%", "20px")}
  ${responsive("right", "-30%", "-30%", "-30%", "inherit")}
  ${responsive("top", "55px", "55px", "55px", "89%")}
  ${responsive("height", "20px", "20px", "20px", "24%")}
  background-image: radial-gradient(#FFE4C5 20%, transparent 16%);
  background-size: 11px 11px;
  ${responsive(
    "background-repeat",
    "repeat-x",
    "repeat-x",
    "repeat-x",
    "repeat-y"
  )}
`

const SubSectionParagraph = styled(Paragraph)`
  width: 100%; /* for IE11 compatibility */
`

const SubSection = ({ headline, image, body, last }) => (
  <SubSectionContainer>
    {!last && <Dots />}
    <LazyResImage
      src={image}
      height={80}
      width={80}
      alt={`A graphic icon for '${headline}'`}
    >
      <Image />
    </LazyResImage>
    <HeadingThree margin="16px 0 6px">{headline}</HeadingThree>
    <SubSectionParagraph margin="0" small>
      {body}
    </SubSectionParagraph>
  </SubSectionContainer>
)

const HowItWorks = ({ headline, sections }) => (
  <Section>
    <StyledHeadingTwo>{headline}</StyledHeadingTwo>
    <InfoContainer>
      {sections.map((s, i) => (
        <SubSection key={s.headline} {...s} last={sections.length - 1 === i} />
      ))}
    </InfoContainer>
  </Section>
)

export { HowItWorks as default }



// WEBPACK FOOTER //
// ./src/components/HowItWorks/index.js